import video from "../../../../content/assets/audio-reactive-led-strip/demo.mp4";
import * as React from 'react';
export default {
  video,
  React
};